<div class="container my-2 d-flex flex-column justify-content-evenly">
	<div class="h-50 mb-5">
		<div class="d-flex flex-row justify-content-between">
			<h4>Pracownicy:</h4>
			<button mat-raised-button color="primary" (click)="openWorkersAdd()">
				<i class="fa-solid fa-user"></i> Dodaj pracownika
			</button>
		</div>
		<mat-table #usersTable [dataSource]="workersData">
			<ng-container matColumnDef="firstName">
				<mat-header-cell *matHeaderCellDef> Imię </mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ element.user?.firstName }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="lastName">
				<mat-header-cell *matHeaderCellDef> Nazwisko </mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ element.user?.lastName }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="email">
				<mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ element.user?.email }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="department">
				<mat-header-cell *matHeaderCellDef> Dział </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{ getDepartment(element.department) }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="role">
				<mat-header-cell *matHeaderCellDef> Stanowisko </mat-header-cell>
				<mat-cell *matCellDef="let element">{{ getRole(element.role) }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="edit">
				<mat-header-cell *matHeaderCellDef> Edytuj </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button mat-raised-button color="primary" (click)="openWorkersEdit(element)">
						<i class="fa-solid fa-user-pen"></i> Edytuj
					</button>
				</mat-cell>
			</ng-container>
			<mat-header-row *matHeaderRowDef="workersColumns; sticky: true"></mat-header-row>
			<mat-row *matRowDef="let row; columns: workersColumns"></mat-row>
		</mat-table>
	</div>
</div>
